

















































































































import {Vue, Component, Prop} from "vue-property-decorator";
import ATableRow from "@common/table/components/table-list/ATableRow.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Spinner from '@service/components/Spinner.vue';
import CloseButton from "@service/components/common/close-button/CloseButton.vue";
import TableSearch from "@share/common/table-search/TableSearch.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import FilterModal from "@common/table/components/filter/FilterModal.vue";
import QuickFilters from "@common/table/components/filter/QuickFilters.vue";
import ControlWrapper from "@share/common/ControlWrapper.vue";
import TableArrows from "@share/common/table-arrows/TableArrows.vue";
import {Debounce} from "vue-debounce-decorator";
import {ParticipantsFiltersAvailability} from "@share/participants-table/types/ParticipantsFiltersAvailability";
import {SelectableTag} from "@api/models/SelectableTag";
import {DynamicScroller, DynamicScrollerItem, RecycleScroller} from 'vue-virtual-scroller';
import {isBottom as isBottomFn} from "@common/isBottom";
import {TagsHelper} from "@common/TagsHelper";
import {Table} from '@common/table/interfaces/Table';
import {DateTime} from "luxon";
import {parseJson} from "@common/TypesHelper";
import {FilterSetting} from "@common/table/interfaces/FilterSetting";
import {FilterSettingTagsData} from "@common/table/interfaces/FilterSettingTagsData";
import {TableColumn} from "@common/table/interfaces/TableColumn";
import { TableHelperInterface } from "@common/table/interfaces/TableHelper";
import {FilterType} from "@common/table/enums/FilterTypes";
import {SelectedFilter} from "@common/table/interfaces/SelectedFilter";
import { TableViewParams } from "@common/table/interfaces/ViewParams";

@Component({
    components: {
        ATableRow,
        TableArrows,
        ControlWrapper,
        FilterModal,
        TableSearch,
        CloseButton,
        BounceSpinner,
        Spinner,
        TagList,
        DynamicScroller,
        DynamicScrollerItem,
        QuickFilters
    }
})

export default class ATable extends Vue implements Table {
    @Prop({default: 'table'}) id: string;
    @Prop({required: true}) tableHelper: TableHelperInterface;
    @Prop({default: null}) filtersAvailability: ParticipantsFiltersAvailability | null;
    @Prop({default: { scrollPosition: undefined }}) viewParams: TableViewParams;

    uniqueTableSelector = '';
    fields: TableColumn[] = [];
    filters: FilterSetting[] = [];
    selectedFilters: { [key: string]: SelectedFilter } = {};

    currentFilter = "createdAt";
    currentFilterIndex = 0;
    isFilterReversed = true;

    searchStr = '';
    searchPlaceholder = '';
    showSearch = true;
    isFiltersModalVisible = false;
    loaded = false;
    isFilterSet = false;

    async created() {
        this.doBeforeCreate();
        this.fields = this.tableHelper.getTableColumns();
        await this.setFilters();
        await this.initializeData();
        this.loaded = true;
        this.showIconFilterSet();
    }

    async mounted() {
        this.currentFilter = this.tableHelper.filterOrder;

        this.$refs['tableHelperList'] && ((this.$refs['tableHelperList'] as any).$el as HTMLElement).addEventListener('scroll', this.listScrollHandler);
        this.searchPlaceholder = this.getPlaceholderText() as string;

        //remove hover
        delete ((this.$refs['tableHelperList'] as typeof DynamicScroller | undefined)?.$refs.scroller as typeof RecycleScroller | undefined)?.$data.hoverKey;
    }

    activated() {
        if(typeof this.viewParams.scrollPosition === "number") {
            this.setScrollToTable(this.viewParams.scrollPosition);
        }
    }

    public getTableScrollPosition() {
        const dynamicScroller: typeof DynamicScroller | undefined = this.$refs['tableHelperList'];

        return dynamicScroller ? dynamicScroller.$el.scrollTop : 0;
    }

    setScrollToTable(vertivalScrollPosition: number) {
        const dynamicScroller: typeof DynamicScroller | undefined = this.$refs['tableHelperList'];

        if(dynamicScroller) {
            dynamicScroller.$el.scrollTo(0, vertivalScrollPosition)
        }
    }

    @Debounce(300)
    async listScrollHandler() {
        if (!this.tableHelper.isLoading && this.tableHelper.count > this.tableHelper.list.length) {

            const isBottom = isBottomFn((this.$refs['tableHelperList'] as any).$el)
            if (isBottom) {
                this.tableHelper.page++;
                await this.initializeData();
            }
        }
    }

    async setFilters() {
        this.doBeforeSetFilters();
        this.filters = await this.tableHelper.getFilterList();
        this.tableHelper.filters = {};
        this.selectedFilters = {};
        let savedFilters: string | null = localStorage.getItem(this.lsKey());

        if (savedFilters) {
            this.selectedFilters = parseJson(savedFilters);
        }

        if (Object.keys(this.selectedFilters).length) {
            Object.keys(this.selectedFilters).forEach((filterName: string) => {
                this.filters.map((filter) => {
                    if (filter?.name === filterName) {
                        if (filter.type === FilterType.tags && filter.tags && Array.isArray(filter.tags)) {
                            filter.tags.map((tagFilter: FilterSettingTagsData) => {
                                if (this.selectedFilters[filterName].selected.includes(tagFilter.tag.id)) {
                                    tagFilter.isSelected = true;
                                    if (!this.tableHelper.filters[filterName]) {
                                        this.tableHelper.filters[filterName] = [];
                                    }
                                    this.tableHelper.filters[filterName].push(tagFilter.tag.id);
                                }
                            });
                        }

                        if (filter.type === FilterType.select) {
                            if (filter.isFieldMultiple) {
                                this.tableHelper.filters[filter.name] = [this.selectedFilters[filter.name].selected.id];
                            } else {
                                this.tableHelper.filters[filter.name] = this.selectedFilters[filter.name].selected.id;
                            }
                            filter.selectedItem = this.selectedFilters[filter.name].selected;
                        }

                        if (filter.type === FilterType.dateRange) {
                            this.tableHelper.filters[filter.name] = this.selectedFilters[filter.name].selected;
                            filter.selectedItem = {
                                start: DateTime.fromFormat(
                                    this.selectedFilters[filter.name].selected.$gte,
                                    'yyyy-LL-dd mm:ss').toFormat('dd.LL.yyyy'
                                ),
                                end: DateTime.fromFormat(
                                    this.selectedFilters[filter.name].selected.$lte,
                                    'yyyy-LL-dd mm:ss').toFormat('dd.LL.yyyy'
                                )
                            };
                        }

                        if (filter.type === FilterType.text) {
                            this.tableHelper.filters[filter.name] = {
                                $regex: `(?i).*${this.selectedFilters[filter.name].value}.*`
                            };
                            filter.value = this.selectedFilters[filter.name].value;
                        }
                    }
                });
            });
        }
    }

    async initializeData() {
        this.doBeforeInitialize();
        this.fields = this.tableHelper.getTableColumns();
        await this.tableHelper.getList();
    }

    getFieldClass(field: TableColumn): string {
        return field?.class ?? '';
    }

    getFieldTitle(field: TableColumn) {
        return field?.label ? field.label : this.$t(this.id + '.columns.' + field.fieldName);
    }

    async applyFilters() {
        this.isFiltersModalVisible = false;
        this.tableHelper.filters = {};
        this.filters.forEach((filterItem: FilterSetting) => {
            if (filterItem.type === FilterType.tags && filterItem.tags) {
                filterItem.tags.forEach((tag: FilterSettingTagsData) => {
                    if (tag.isSelected) {
                        if (!this.tableHelper.filters[tag.parent]) {
                            this.tableHelper.filters[tag.parent] = [];
                        }
                        this.tableHelper.filters[tag.parent].push(tag.tag.id);
                    }
                });
            }

            if (
                filterItem.type === FilterType.select &&
                filterItem.selectedItem &&
                Object.keys(filterItem.selectedItem).length &&
                filterItem.selectedItem.id
            ) {
                if (filterItem.isFieldMultiple) {
                    this.tableHelper.filters[filterItem.name] = [filterItem.selectedItem.id];
                } else {
                    this.tableHelper.filters[filterItem.name] = filterItem.selectedItem.id;
                }
            }

            if (
                filterItem.type === FilterType.dateRange &&
                this.selectedFilters[filterItem.name] &&
                Object.keys(this.selectedFilters[filterItem.name].selected).length
            ) {
                this.tableHelper.filters[filterItem.name] = this.selectedFilters[filterItem.name].selected;
            }

            if (filterItem.type === FilterType.text) {
                let text: string = filterItem.value ? filterItem.value.trim() : '';
                if (text && text.length) {
                    this.tableHelper.filters[filterItem.name] = {
                        $regex: `(?i).*${text}.*`
                    };
                    this.selectedFilters[filterItem.name] = {
                        value: text
                    }
                } else {
                    delete this.selectedFilters[filterItem.name];
                }
            }
        });

        if (Object.keys(this.selectedFilters).length) {
            localStorage.setItem(this.lsKey(), JSON.stringify(this.selectedFilters));
        } else {
            localStorage.removeItem(this.lsKey());
        }

        this.showIconFilterSet();
        this.tableHelper.page = 1;
        await this.initializeData();
    }

    async resetFilters() {
        this.isFiltersModalVisible = false;
        this.tableHelper.filters = {};
        this.selectedFilters = {};
        localStorage.removeItem(this.lsKey());
        this.showIconFilterSet();
        await this.initializeData();
    }

    showIconFilterSet() {
        this.isFilterSet = Boolean(Object.keys(this.tableHelper.filters).length);
    }

    async accumulateFilters(tagWrapper: SelectableTag) {
        this.filters.forEach((item, key) => {
            if (item.type === FilterType.tags && tagWrapper.parent && item.name === tagWrapper.parent) {
                this.selectedFilters[tagWrapper.parent] = {
                    selected: [],
                    type: FilterType.tags,
                };

                let filterKey = this.filters[key];
                if (filterKey && filterKey.tags && Array.isArray(filterKey.tags)) {
                    TagsHelper.switchSelection(filterKey.tags, tagWrapper);
                    filterKey.tags.forEach((item: FilterSettingTagsData) => {
                        if (item.isSelected) {
                            this.selectedFilters[item.parent].selected.push(item.tag.id);
                        }
                    });
                }

                if (!this.selectedFilters[tagWrapper.parent].selected.length) {
                    delete this.selectedFilters[tagWrapper.parent];
                }
            }
        });
    }

    setSelectFilter(filter: FilterSetting) {
        if (filter.selectedItem && Object.keys(filter.selectedItem).length) {
            if (!this.selectedFilters[filter.name]) {
                this.selectedFilters[filter.name] = {
                    selected: {},
                    type: FilterType.select,
                };
            }

            this.selectedFilters[filter.name].selected = filter.selectedItem;

            if (
                Object.keys(this.selectedFilters[filter.name].selected).length &&
                !this.selectedFilters[filter.name].selected.id
            ) {
                delete this.selectedFilters[filter.name];
            }

        } else {
            delete this.selectedFilters[filter.name];
        }
    }

    changedDatePickerRange(value: { start?: string; end?: string }, filterName = '') {
        if (Object.keys(value)) {
            if (!this.selectedFilters[filterName]) {
                this.selectedFilters[filterName] = {
                    selected: {},
                    type: FilterType.dateRange,
                };
            }

            let startDate: string = value.start ?? '';
            let endDate: string = value.end ?? '';

            if (value.start && !value.end) {
                startDate = value.start;
                endDate = startDate;
            }

            if (!value.start && value.end) {
                endDate = value.end;
                startDate = endDate;
            }

            if (startDate && endDate) {
                startDate += ' 00:00';
                endDate += ' 23:59';
                this.selectedFilters[filterName].selected = {
                    $gte: startDate,
                    $lte: endDate
                };
            } else {
                delete this.selectedFilters[filterName];
            }

        } else {
            delete this.selectedFilters[filterName];
        }
    }

    getPlaceholderText() {
        return this.$t('common.search');
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    async toggleFilter(fieldName: string, index = 0, filterable = true) {
        if (!filterable) {
            return false;
        }

        if (this.tableHelper.searchStr) {
            return;
        }
        const sanitizedFieldName = fieldName[0].toLowerCase() + fieldName.slice(1);
        if (this.currentFilter === fieldName) {
            this.isFilterReversed = !this.isFilterReversed;
        } else {
            this.currentFilterIndex = index;
            this.isFilterReversed = false;
            this.currentFilter = fieldName;

        }
        this.tableHelper.filterOrder = sanitizedFieldName;
        this.tableHelper.filterDirection = this.isFilterReversed ? "desc" : "asc"
        this.tableHelper.page = 1;

        this.tableHelper.sortOnClient ? this.tableHelper.sortList() : await this.initializeData();
    }

    @Debounce(500)
    async onSearchInput() {
        this.tableHelper.page = 1;
        await this.initializeData();
        this.$nextTick(() => {
            (this.$refs['tableHelperList'] as any).scrollToItem(0);
        });
    }

    async clearInput() {
        this.tableHelper.searchStr = "";
        await this.onSearchInput();
    }

    get searchPanelTags() {
        return []
    }

    get maxTagsToShow() {
        return window.innerWidth < 1024 ? 0 : 5;
    }

    lsKey() {
        return this.backend + this.$store.getters.userId + '_' + this.id + '-filter';
    }

    showFiltersModal() {
        this.isFiltersModalVisible = true;
    }

    get showListSpinner() {
        return this.tableHelper.isLoading && this.tableHelper.page > 1;
    }

    get showComponentSpinner() {
        return this.tableHelper.isLoading && this.tableHelper.page === 1;
    }

    doBeforeCreate(): void {
        // ...
    }

    doBeforeInitialize(): void {
        // ...
    }

    doBeforeSetFilters(): void {
        // ...
    }

    routeName(): string {
        return ''
    }
}
